module.exports = __webpack_public_path__ + "static/media/elegance.e78e08a9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/elegance.jpeg
// module id = 275
// module chunks = 0